// Types
import { ReviewFormTemplateType } from 'Shared/types/ReviewFormTemplate.type';

// Utils
import {
  getReviewFormTemplateErrors,
  getReviewFormTemplateQuestionErrors,
} from 'Shared/utils/ReviewFormTemplate.utils';

type Props = {
  reviewFormTemplate: ReviewFormTemplateType;
};

export const useReviewFormTemplate = ({ reviewFormTemplate }: Props) => {
  const title = {
    peer_review: 'Peer Questions',
    self_peer_review: 'Self Questions',
    manager_peer_review: 'Manager Questions',
    compilation: 'Summarizer Questions',
    feedback: 'Questions',
  }[reviewFormTemplate.formType];

  const description = {
    peer_review: 'These are questions that peers will answer about the feedback recipient.',
    self_peer_review: 'These are questions the recipient will answer about their own experience. ',
    manager_peer_review: 'These are questions that the manager will answer about their direct report.',
    compilation: 'These are questions the summarizer will answer at the end of the process.',
    feedback: 'Add or edit questions for this template.',
  }[reviewFormTemplate.formType];

  const formErrors = getReviewFormTemplateErrors({ reviewFormTemplate });
  const questionCount = reviewFormTemplate.questions.length;
  const questionErrors = getReviewFormTemplateQuestionErrors({ reviewFormTemplate });

  return {
    title,
    description,
    questionCount,
    formErrors,
    questionErrors,
  };
};
